import { actions } from "./Reducer";
/**
 * Actions that fire saga watchers
 */

// Singular
export const updatePendingPublicInquiryAction = (body) => ({
  type: actions.UPDATE_PENDING_ARTISAN_PUBLIC_INQUIREY,
  payload: body,
});

export const getSinglePendingPublicArtisanInquiryAction = (id) => ({
  type: actions.GET_SINGLE_ARTISAN_PUBLIC_INQUIRY,
  payload: id
})

export const deleteSingleArtisanPublicInquiryAction = (id) => ({
  type: actions.DELETE_SINGLE_ARTISAN_PUBLIC_INQUIRY,
  payload: id
})

export const moderateCreateArtisanPublicAction = (id, mode) => ({
  type: actions.MODERATE_CREATE_ARTISAN_PUBLIC_INQUIRY,
  payload: id,
  mode
})
// Plural
export const getPendingPublicInquiriesAction = (body) => ({
  type : actions.GET_PENDING_ARTISANS_PUBLIC_INQUIRIES,
  payload : body
})

/**
 * Actions that are fired by redux-saga watchers
*/

// Singular



export const getSinglePendingPublicArtisanInquirySuccessAction = (inquiry) => ({
  type: actions.GET_SINGLE_ARTISAN_PUBLIC_INQUIRY_SUCCESS,
  payload: inquiry
})

export const deleteSingleArtisanPublicInquirySuccessAction = (id) => ({
  type: actions.DELETE_SINGLE_ARTISAN_PUBLIC_INQUIRY_SUCCESS,
  payload: id
})

export const moderateCreateArtisanPublicSuccessAction = (id) => ({
  type: actions.MODERATE_CREATE_ARTISAN_PUBLIC_INQUIRY_SUCCESS,
  payload: id
})
// Plural
export const getPendingPublicInquiriesSuccessAction = (body) => ({
  type : actions.GET_PENDING_ARTISANS_PUBLIC_INQUIRIES_SUCCESS,
  payload : body
})

/**
 * Misc
 */

export const setPendingPublicInquiryIsLoadingAction = (isLoading) => ({
  type: actions.SET_PENDING_ARTISANS_PUBLIC_INQUIRY_IS_LOADING,
  payload: isLoading,
});

export const setPendingPublicInquiryCountAction = (count) => ({
  type: actions.SET_PENDING_ARTISANS_PUBLIC_INQUIRY_COUNT,
  payload: count,
});
